import { IUser, ROLES } from '@aksia/infrastructure';

export class User implements IUser {
  constructor(user?: IUser) {
    if (user) {
      this.userId = user.userId;
      this.userName = user.userName;
      this.email = `${user.userName}@aksia.com`;
      //this.abbr = user.userName.substring(0, 2)?.toUpperCase();
      this.fullName = user.fullName;
      if (user.roles?.includes(ROLES.ADMIN)) {
        this.roles = [ROLES.ADMIN];
      } else {
        this.roles = user.roles?.filter((role) =>
          ROLES.toKeyValue().some((r) => r.value === role),
        );
      }
    }
  }
}

export interface User extends IUser {}
